import * as React from 'react';
import {PropsWithChildren, useState} from 'react';
import {useCache} from '../../shared-common/hooks/useCache';
import DataService from '../../shared/services/DataService';
import {BusinessUnitCache} from '../../shared-common/context/BusinessUnitCache';
import {BusinessUnitFilter} from '../../shared-common/types/BusinessUnitFilter';
import {BusinessUnitEntry} from '../types/BusinessUnitEntry';

export const BusinessUnitStore = (props: PropsWithChildren<{}>) => {
  const [isProcessing, setIsProcessing] = useState<boolean>();

  const {clearCache, getValue} = useCache<BusinessUnitFilter, BusinessUnitEntry[]>(
    async (key: BusinessUnitFilter) => {
      setIsProcessing(true);
      try {
        return await DataService.tryLoad<BusinessUnitEntry[]>(
          '/master-data/get-filtered-business-units', {
            clientId: key.clientId,
            virtualStructureId: key.virtualStructureId,
            useLatestStructure: key.useLatestStructure,
            unitIds: key.unitIds,
            datasetIds: key.datasetIds,
            onlyWithResponses: key.onlyWithResponses
          });
      } finally {
        setIsProcessing(false);
      }
    }
  );

  const getUnits = (filter: BusinessUnitFilter) => {
    return getValue(filter);
  };

  const clearBusinessUnitCache = () => {
    clearCache();
  };

  return (
    <BusinessUnitCache.Provider
      value={{
        getUnits: getUnits,
        clearBusinessUnitCache: clearBusinessUnitCache,
        isBusinessUnitCacheProcessing: isProcessing
      }}
    >
      {props.children}
    </BusinessUnitCache.Provider>
  );
};
